export default __webpack_public_path__ + "static/media/tab_more_active.1b5b2560.svg";